import MyTeamManageShiftComponent from "../components/MyTeamManageShift";
import useMyTeamManageShift from "../hooks/useMyTeamManageShift";

function MyTeamManageShift() {
  const useMyTeamManageShiftProps = useMyTeamManageShift();
  return <MyTeamManageShiftComponent {...useMyTeamManageShiftProps} />;
}

export default MyTeamManageShift;
